import { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import { baseURL } from "../../Utils/constants/constant";
import { ImportStep1 } from "./ImportStep1";
import { ImportStep2 } from "./ImportStep2";
import { ImportStep3 } from "./ImportStep3";

export const ImportData = () => {
  const location = useLocation();
  const data = location.state || null;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [overwriteColumn, setOverwriteColumn] = useState(null);
  const [currentSelected, setCurrSelected] = useState("skip");
  const [currentStep, setCurrStep] = useState(1);
  const [files, setFiles] = useState([]);
  // const [fetchingStatus, setFetchingStatus] = useState(false);
  const [fileHeaders, setFileHeaders] = useState([]);
  // const [fieldGroups, setFieldGroups] = useState([]);
  const [values, setValues] = useState();
  const [importResult, setImportResult] = useState(null);
  const [unmappedCount, setUnmappedCount] = useState(0);

  const [mapping, setMapping] = useState({});
  // Session storage and authentication setup
  const [customer, setCustomer] = useLocalStorageState("customer");
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;

  useEffect(() => {
    if (!data || data === null || !data.module_name || data.module_name === undefined) {
      navigate("/dashboard");
      return;
    }
    return () => { };
  }, [data]);

  // API headers configuration
  const headers = {
    Authentication: rf,
    Authorization: token,
  };

  const extras = {
    customer,
    setCustomer,
    rf,
    navigate,
  };


  const toKey = (value = "") =>
    String(value).toLowerCase().trim().replace(/\s+/g, "_");

  const createInitialMapping = (fieldData = [], fileHeaders = []) => {
    const usedHeaderValues = new Set();

    const headersByName = fileHeaders.reduce((acc, header) => {
      acc[toKey(header.value)] = header;
      return acc;
    }, {});

    const mapping = fieldData.reduce((groups, group) => {
      const groupName = toKey(group.title);

      groups[groupName] = (group.fields || []).reduce((fields, field) => {
        const fieldName = toKey(field.id);
        const matchingHeader = headersByName[fieldName];

        if (matchingHeader && !usedHeaderValues.has(matchingHeader.value)) {
          fields[field.id] = matchingHeader;
          usedHeaderValues.add(matchingHeader.value);
        }

        return fields;
      }, {});

      return groups;
    }, {});

    return mapping;
  };

  useEffect(() => {
    if (data?.fieldData && fileHeaders?.length) {
      const mapping = createInitialMapping(data.fieldData, fileHeaders);

      setMapping(mapping);
    }
  }, [currentStep, data?.fieldData, fileHeaders]);

  return (
    <>
      <div className="d-flex  justify-content-between align-items-center mb-3 flex-wrap">
        <div>
          <h2 className="mb-2 mb-md-0" style={{ fontSize: "1.5rem" }}>
            Import Data Of{" "}
            <span style={{ textTransform: "capitalize" }}>
              {data?.module_name}
            </span>
          </h2>
          <p>List of current shifts within your organization.</p>
        </div>

        <div className="d-flex align-items-center gap-2">
          {/* Back Button */}
          <div
            className="btn btn-default-outline"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowLeft className="me-1" /> Back
          </div>
        </div>
      </div>
      <div className="container-fluid d-flex flex-column p-3 create-shift-container mb-5 ">
        {currentStep === 1 && (
          <ImportStep1
            headers={headers}
            extras={extras}
            data={data}
            loading={loading}
            files={files}
            setFiles={setFiles}
            currentStep={currentStep}
            setCurrStep={setCurrStep}
            currentSelected={currentSelected}
            setCurrSelected={setCurrSelected}
            setFileHeaders={setFileHeaders}
            setValues={setValues}
            module_name={data?.module_name}
          />
        )}
        {currentStep === 2 && (
          <ImportStep2
            data={data}
            customer={customer}
            headers={headers}
            extras={extras}
            loading={loading}
            setLoading={setLoading}
            files={files}
            fileHeaders={fileHeaders}
            values={values}
            currentSelected={currentSelected}
            setCurrSelected={setCurrSelected}
            setUnmappedCount={setUnmappedCount}
            setCurrStep={setCurrStep}
            setImportResult={setImportResult}
            mapping={mapping}
            setMapping={setMapping}
          />
        )}
        {currentStep === 3 && (
          <ImportStep3
            data={data}
            customer={customer}
            headers={headers}
            extras={extras}
            loading={loading}
            setLoading={setLoading}
            importResult={importResult}
            fileHeaders={fileHeaders}
            currentSelected={currentSelected}
            unmappedCount={unmappedCount}
            setCurrStep={setCurrStep}
          />
        )}
        <style jsx>
          {`
            .custom-radio .form-check-input {
              height: 21px;
              background-color: var(--custom-white);
              border: 1px solid var(--input-border);
            }
            .custom-radio .form-check-input:checked {
              height: 21px;
              background-color: var(--primary-color);
              border-color: var(--primary-color);
            }
          `}
        </style>
      </div>
    </>
  );
};